(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["milo-reels"] && !Shopify.designMode) return;
  try {
    
  // Play each reel only when it scrolls into view and motion is allowed;
  // pause when out of view so it isn't decoding off-screen.
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        v.dataset.inView = e.isIntersecting ? 'true' : 'false';
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('.reels__video').forEach(function (v) {
      v.addEventListener('ended', function () {
        if (v.dataset.inView !== 'true') return;
        v.currentTime = 0;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
      io.observe(v);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
